import { useEffect, useState } from 'react'

export const useIsStandalone = () => {
  const [isStandalone, setIsStandalone] = useState(false)

  useEffect(() => {
    const compute = () => {
      try {
        const matchStandalone = window.matchMedia('(display-mode: standalone)')
        const isMatch = matchStandalone?.matches === true
        // iOS Safari adds `navigator.standalone`
        const isiOSStandalone = (navigator && navigator.standalone === true) || false
        return isMatch || isiOSStandalone
      } catch {
        return false
      }
    }

    setIsStandalone(compute())

    let mq = null
    try {
      mq = window.matchMedia('(display-mode: standalone)')
      if (mq && typeof mq.addEventListener === 'function') {
        const handler = () => setIsStandalone(compute())
        mq.addEventListener('change', handler)
        return () => {
          mq?.removeEventListener('change', handler)
        }
      }
    } catch {
      // ignore
    }

    return
  }, [])

  return isStandalone
}

export default useIsStandalone

